import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';

import SaveToAccountComponent from '../components/menu-bar/save-to-account.jsx';
import {getCloudProjectName, getIsSavingProject} from '../reducers/cloud-project.js';
import {getIsLoggedIn} from '../reducers/auth.js';
import {openSaveProjectModal} from '../reducers/modals.js';

/*
 * The menu bar save button.
 *
 * It no longer writes anything itself: clicking it opens the naming dialog,
 * which is where the project name is chosen and the upload happens. Keeping the
 * button this thin means there is exactly one code path that talks to the
 * service, so the button and the dialog can never disagree about the state.
 */
class SaveToAccount extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleClick'
        ]);
    }

    handleClick () {
        if (this.props.isSaving) return;
        this.props.onOpenSaveProjectModal();
    }

    render () {
        return (
            <SaveToAccountComponent
                isSaving={this.props.isSaving}
                savedAt={this.props.savedAt}
                onClick={this.handleClick}
            />
        );
    }
}

SaveToAccount.propTypes = {
    isSaving: PropTypes.bool,
    onOpenSaveProjectModal: PropTypes.func,
    savedAt: PropTypes.number
};

const mapStateToProps = state => ({
    isLoggedIn: getIsLoggedIn(state.scratchGui.auth),
    isSaving: getIsSavingProject(state.scratchGui.cloudProject),
    savedAt: state.scratchGui.cloudProject.savedAt,
    savedName: getCloudProjectName(state.scratchGui.cloudProject)
});

const mapDispatchToProps = dispatch => ({
    onOpenSaveProjectModal: () => dispatch(openSaveProjectModal())
});

// The button is useless without a signed-in account, so it is not rendered at
// all for anonymous users (the menu bar decides where to place it).
const ConnectedSaveToAccount = connect(
    mapStateToProps,
    mapDispatchToProps
)(SaveToAccount);

export default ConnectedSaveToAccount;
export {SaveToAccount as SaveToAccountUnconnected};
